export default "__VITE_ASSET__D03q5mqq__"